import { CHART_COLORS, seriesColumnConfig } from './chartStyle';

/**
 * Configuration function for set subscription chart data.
 * @param {Array} data - Data for the subscription chart.
 * @returns {Object} - Configuration object for the subscription chart.
 */
export const setSubscriptionChartConfig = (data) => ({
  ...seriesColumnConfig({
    domain: ['N-1', 'N'],
    colors: [CHART_COLORS.mutedLight, CHART_COLORS.cambridge]
  }),
  data,
  xField: 'month',
  yField: 'sales',
  tooltip: {
    items: [(item) => ({ name: item.type, value: `${item.sales} €` })]
  }
});
